<section class="before-selfie">
  <img src="assets/images/verify_selfie.svg" width="200" alt="selfie">

  <div class="before-selfie__title">Tire uma foto sua</div>


  <p>Agora precisamos de uma foto sua, <strong>somente do seu rosto,</strong> para garantirmos que ninguém está se passando por você.</p>

  <p><strong>Não tire foto de outra foto</strong> e tenha cuidado para <strong>não cobrir seu rosto.</strong> Não se preocupe, <strong>esta foto não será divulgada.</strong></p>
</section>
